function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Vote"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M21 14.2H19V16.2H19.7C19.8656 16.2 20 16.3125 20 16.45V16.95C20 17.0875 19.8656 17.2 19.7 17.2H4.3C4.13437 17.2 4 17.0875 4 16.95V16.45C4 16.3125 4.13437 16.2 4.3 16.2H5V14.2H3C2.44687 14.2 2 14.6468 2 15.2V18.2C2 18.7531 2.44687 19.2 3 19.2H21C21.5531 19.2 22 18.7531 22 18.2V15.2C22 14.6468 21.5531 14.2 21 14.2ZM18 16.2V6.20933C18 5.64995 17.5469 5.19995 16.9906 5.19995H7.0125C6.45312 5.19995 6 5.65308 6 6.20933V16.2H18ZM8.6 10.5125L9.39687 9.72183C9.52812 9.59058 9.74062 9.59058 9.87187 9.72495L11.1625 11.025L14.1375 8.07495C14.2687 7.9437 14.4813 7.9437 14.6125 8.07808L15.4031 8.87495C15.5344 9.0062 15.5344 9.2187 15.4 9.34995L11.3906 13.325C11.2594 13.4562 11.0469 13.4562 10.9156 13.3218L8.6 10.9875C8.46562 10.8562 8.46875 10.6437 8.6 10.5125V10.5125Z",
  fill: "none"
}));

var SvgVote = function SvgVote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vote.08ba4e76.svg";
export { ForwardRef as ReactComponent };